import { AgGridColumnExt } from "../../../../shared/services/ag-grid/agGridColumnExt";
import ApiService from "../../../../shared/services/apiService"
import { API_ENDPOINT } from "../../../../shared/types/enums"

export default class TransactionSearchDialogService {

    static searchOBS = (_tenantId, _searchValue) => {
        return ApiService.setOBS("POST", API_ENDPOINT.CORE, `/Transactions/FetchTransactionsSearchValue/${_tenantId}`, JSON.stringify({
            searchValue: _searchValue,
            porzioGSTId: "",
            firstName: "",
            lastName: "",
            organizationName: "",
            companyId: "",
            country: "",
            isAdvance: false
        }));
    }

    static getColumnDefs = (_componentThisRef, _onSelectCallback) => {
        return [
            AgGridColumnExt.GET(false, "text", "companyTransactionId", "Company Transaction ID").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "porzioGstTransactionId", "Porzio GST Transaction ID").minAndDefaultWidth(136).flexWeight(1).headerClass("center-text").centerAlignText().cellRenderer("childMessageRendererComponent").SET(),
            AgGridColumnExt.GET(false, "text", "porzioGSTProfileId", "Porzio GST Profile ID").minAndDefaultWidth(136).flexWeight(1).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "fileName", "File Name").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "set", "sourceName", "Source").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, true, "transactionStatus", "Transaction Status").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "transactionDate", "Transaction Date").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "lastName", "Last Name").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "firstName", "First Name").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "middleName", "Middle Name").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "text", "organizationName", "Organization Name").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, true, "country", "Country").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
            AgGridColumnExt.GET(false, "number", "totalAmount", "Total Amount").flexWeight(1).minWidth(136).headerClass("center-text").centerAlignText().SET(),
        ];
    }
}